import { getKbConfig } from "@/features/branding";
import { Tool } from "@/types/tools";
import { resolveDocument360DeepLinkUrl } from "@/utils/document360";
import CommentOutlined from "@ant-design/icons/es/icons/CommentOutlined";
import { useSession } from "@supabase/auth-helpers-react";
import { useRouter } from "next/router";
import { useEffect } from "react";
const buildSidebarDeepLinkRedirect = async (accessToken: string | undefined) => {
  const {
    publicDocsUrl
  } = getKbConfig().faqs;
  if (publicDocsUrl) {
    try {
      return await resolveDocument360DeepLinkUrl(publicDocsUrl, accessToken);
    } catch (err) {
      const message = err instanceof Error ? err.message : err;
      console.log("Failed to authenticate with Document360 - directing without login", message);
    }
  }
  return publicDocsUrl || "/faqs/_";
};
const buildSidebarRedirect = () => getKbConfig().faqs?.publicDocsUrl || "/faqs/_";
const Render = () => {
  const router = useRouter();
  const session = useSession();
  const redirect = async () => {
    router.replace(
    // Temporarily give knowledge base access just to TCRG Dev.
    // TODO: Properly detect if this is a knowledge base link.
    process.env.NEXT_PUBLIC_THEME_NAME?.startsWith("tcrg") ? await buildSidebarDeepLinkRedirect(session?.access_token || undefined) : buildSidebarRedirect());
  };
  useEffect(() => {
    redirect();
  }, []);
  return <></>;
};
export default {
  id: "faqs",
  category: "reference",
  keyPrefix: "reference.faqs",
  icon: <CommentOutlined />,
  render: () => <Render />,
  buildSidebarRedirect
} as Tool;